import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CloudIcon from "@mui/icons-material/Cloud";

function ProductCell({ name }) {
  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mr={2}>
        <CloudIcon fontSize="medium" color="info" />
      </SoftBox>
      <SoftTypography variant="button" fontWeight="medium">
        {name}
      </SoftTypography>
    </SoftBox>
  );
}

// PropTypes Validierung
ProductCell.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ProductCell;